import type { ActivationAlertsContractDisplayAdFeedGroup } from "@similarweb/pro-api-client";
import { Stack } from "@similarweb/ui-components/foundations";

import { useApiQuery } from "app/modules/api-client";

import { useAlertsParams } from "../../../../../hooks/useAlertsParams";
import { AdPreviewSection } from "../AdPreviewSection";
import { AlertFallback } from "../AlertFallback";

import { AdDetailsSection } from "./AdDetailsSection";
import { PublishersSection } from "./PublishersSection";

type DisplayAdContentProps = {
    group: ActivationAlertsContractDisplayAdFeedGroup;
    selectedItemIndex: number;
    shouldFetchMoreAds: boolean;
};

export const DisplayAdContent = ({ group, selectedItemIndex, shouldFetchMoreAds }: DisplayAdContentProps) => {
    const { activationId } = useAlertsParams();
    const { data, isError, refetch } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsAdsDisplayDomainDetail",
            options: {
                placeholderData: group,
                enabled: shouldFetchMoreAds,
            },
        },
        {
            domain: group.domain,
            activationId,
        },
    );

    const retry = () => {
        void refetch();
    };

    const currentAd = data?.ads[selectedItemIndex];

    if (!currentAd) {
        return (
            <AlertFallback
                isError={isError}
                retry={retry}
            />
        );
    }

    return (
        <>
            <AdPreviewSection
                imageUrl={currentAd.imageUrl}
                videoUrl={"videoUrl" in currentAd ? currentAd.videoUrl : null}
            />
            <Stack
                gap="32px"
                minWidth={0}
                flex={1}
            >
                <AdDetailsSection ad={currentAd} />
                <PublishersSection publishers={currentAd.publishers} />
            </Stack>
        </>
    );
};
